export const unselectedState = {
  id: null,
  price: 0,
  selectedAsPackage: false,
};
